(function () {
  'use strict';

  var STORAGE_KEY = '__es_cart_localization';
  var REBUY_WAIT_MS = 5000;
  var REBUY_POLL_MS = 100;

  var GROUPS = [
    { idKey: '_mgId', chargeKey: '_monogramCharges', discountFlag: '_isMonogramDiscount', discountValue: '_monogramDiscount' },
    { idKey: '_giftBoxId', chargeKey: '_giftBoxCharges', discountFlag: '_isGiftDiscount', discountValue: '_giftDiscount' },
    { idKey: '_wristId', chargeKey: '_wristStrapCharges', discountFlag: '_isStrapDiscount', discountValue: '_strapDiscount' },
    { idKey: '_giftNoteId', chargeKey: '_giftNoteCharges', discountFlag: null, discountValue: null }
  ];

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function readStamp() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function writeStamp(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      return;
    }
  }

  function effectiveCents(baseCents, properties, group) {
    if (!group.discountFlag) return baseCents;
    if (String(properties[group.discountFlag]).toLowerCase() !== 'true') return baseCents;

    var percent = parseFloat(String(properties[group.discountValue] || '0').replace('%', '').trim());
    if (!isFinite(percent) || percent <= 0) return baseCents;

    var multiplier = 100 - percent;
    if (multiplier < 0) multiplier = 0;

    var discounted = Math.floor((baseCents * multiplier) / 100);
    return discounted > 0 ? discounted : 0;
  }

  function formatCharge(cents) {
    var value = (cents / 100).toFixed(2);
    if (value.indexOf('.') !== -1) value = value.replace(/0+$/, '').replace(/\.$/, '');
    return value === '' || value === '-' ? '0' : value;
  }

  function chargeToCents(value) {
    var amount = parseFloat(String(value).replace(',', '.'));
    return isFinite(amount) ? Math.round(amount * 100) : null;
  }

  function withoutBlanks(properties) {
    var result = {};
    Object.keys(properties || {}).forEach(function (key) {
      if (properties[key] !== '' && properties[key] !== null) result[key] = properties[key];
    });
    return result;
  }

  function buildPriceMap(rows) {
    var map = {};
    (rows || []).forEach(function (row) {
      if (row && row.variant_id != null && typeof row.price === 'number') {
        map[String(row.variant_id)] = row.price;
      }
    });
    return map;
  }

  function repriceLine(item, priceMap) {
    var properties = withoutBlanks(item.properties);
    var changed = false;

    GROUPS.forEach(function (group) {
      var variantId = properties[group.idKey];
      if (variantId == null || variantId === '') return;
      if (!(group.chargeKey in properties)) return;

      var basePrice = priceMap[String(variantId)];
      if (typeof basePrice !== 'number') return;

      var nextCents = effectiveCents(basePrice, properties, group);
      var currentCents = chargeToCents(properties[group.chargeKey]);
      if (currentCents === nextCents) return;

      properties[group.chargeKey] = formatCharge(nextCents);
      changed = true;
    });

    return changed ? properties : null;
  }

  function sectionRenderer() {
    var element = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    if (!element || typeof element.getSectionsToRender !== 'function') return null;

    var sections;
    try {
      sections = element.getSectionsToRender();
    } catch (e) {
      return null;
    }

    return {
      sections: sections.map(function (section) {
        return section.section;
      }),
      render: function (state) {
        sections.forEach(function (section) {
          var host = document.getElementById(section.id);
          if (!host || !state.sections || !state.sections[section.section]) return;
          var target = host.querySelector(section.selector) || host;
          try {
            target.innerHTML = element.getSectionInnerHTML(state.sections[section.section], section.selector);
          } catch (e) {
            return;
          }
        });
      }
    };
  }

  function changeUrl(localization) {
    return (localization && localization.cart_change_url) ||
      (window.routes && window.routes.cart_change_url) ||
      '/cart/change.js';
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function rebuyCart() {
    var cart = window.Rebuy && window.Rebuy.Cart;
    return cart && typeof cart.changeItem === 'function' ? cart : null;
  }

  function waitForRebuyCart() {
    return new Promise(function (resolve) {
      var waited = 0;
      (function check() {
        var cart = rebuyCart();
        if (cart || waited >= REBUY_WAIT_MS) return resolve(cart);
        waited += REBUY_POLL_MS;
        setTimeout(check, REBUY_POLL_MS);
      })();
    });
  }

  function rebuyChangeItem(cart, body) {
    return new Promise(function (resolve, reject) {
      var result = cart.changeItem(body, {
        success: resolve,
        error: function (error) {
          reject(error || new Error('Rebuy.Cart.changeItem failed'));
        }
      });
      if (result && typeof result.then === 'function') result.then(resolve, reject);
    });
  }

  async function syncWithRebuy(cart, updates) {
    for (var index = 0; index < updates.length; index++) {
      var update = updates[index];
      await rebuyChangeItem(cart, {
        id: update.item.key,
        quantity: update.item.quantity,
        properties: update.properties
      });
    }

    var lastState = await fetchCart();

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'currency-cart-sync', cartData: lastState });
    }
  }

  async function sync(localization, priceMap) {
    var cart = await fetchCart();
    if (!cart || !cart.items || !cart.items.length) return;

    var updates = [];
    cart.items.forEach(function (item) {
      var properties = repriceLine(item, priceMap);
      if (properties) updates.push({ item: item, properties: properties });
    });
    if (!updates.length) return;

    var rebuy = await waitForRebuyCart();
    if (rebuy) return syncWithRebuy(rebuy, updates);

    var renderer = sectionRenderer();
    var url = changeUrl(localization);
    var lastState = null;

    for (var index = 0; index < updates.length; index++) {
      var update = updates[index];
      var isLast = index === updates.length - 1;
      var body = {
        id: update.item.key,
        quantity: update.item.quantity,
        properties: update.properties
      };

      if (isLast && renderer) {
        body.sections = renderer.sections;
        body.sections_url = window.location.pathname;
      }

      var response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });

      if (!response.ok) throw new Error('cart/change failed with ' + response.status);
      lastState = await response.json();
    }

    if (renderer && lastState) renderer.render(lastState);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'currency-cart-sync', cartData: lastState });
    }
  }

  function init() {
    var localization = readJson('cartdata-localization');
    if (!localization) return;

    var stamp = String(localization.country || '') + '|' + String(localization.currency || '');
    var previous = readStamp();

    writeStamp(stamp);

    if (!previous || previous === stamp) return;

    var priceMap = buildPriceMap(readJson('cartdata-updated'));
    if (!Object.keys(priceMap).length) return;

    sync(localization, priceMap).catch(function (error) {
      console.error('[currency-cart-sync]', error);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
